// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SuccessBox_wrapper__M7g3_","title":"SuccessBox_title__rq5qQ","description":"SuccessBox_description__sE1tr"};